export default {"src":"/_next/static/media/Facebook.439cbbb2.svg","height":32,"width":32};